import usePermission from "hooks/usePermission";
import { Navigate, Route, RouteProps, Routes } from "react-router-dom";
import { PermissionEnum } from "TypesAndInterfaces";
import { AdyenRoutesName } from "./route-names";
import { getRoutePath } from "./route-utils";

type A = RouteProps;
type IProps = A & {
  permission: PermissionEnum;
};

const ProtectedRoute = ({ element, permission, ...rest }: IProps) => {
  const { isAuthorized } = usePermission(permission);

  return isAuthorized ? (
    <Routes>
      <Route {...rest} element={element} />
    </Routes>
  ) : (
    <Navigate to={getRoutePath(AdyenRoutesName.DASHBOARD_MARKETPLACES)} />
  );
};
export default ProtectedRoute;
